import * as React from 'react'
import LocalizationStore from '../../../../Stores/LocalizationStore'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import HttpActionsService from '../../../../Services/HttpActionsService'
import CreditsStore from '../../../../Stores/CreditsStore'
import CreditView from '../../../PartialViews/Credit/CreditView'
import PageView from '../../../PartialViews/PageView'
import DebtInfoView from '../../../PartialViews/TroubleEvent/DebtInfoView'
import { getPaymentSchedule } from '../../../../Helpers/PaymentScheduleHelper'
import PaymentScheduleView from '../../../PartialViews/PaymentSchedule/PaymentScheduleView'
import PaymentsView from '../../../PartialViews/Payment/PaymentsView'
import { action } from 'mobx'
import ConfigStore from '../../../../Stores/ConfigStore'
import LanguageSelectorView from '../../../PartialViews/LanguageSelector/view'
import NotificationsView from '../../../PartialViews/NotificationsView'
import NotificationsStore from '../../../../Stores/NotificationsStore'
import * as _ from 'lodash'
import { Row, Col, ProgressBar } from 'react-bootstrap'
import { Header } from 'react-bootstrap/lib/Modal'
import ProductsListView from '../../../PartialViews/Product/ProductListView'
import { getProductsSum } from '../../../../Helpers/ProductHelper'
import { getQuestionnaireStatusClass, getQuestionnaireStatusTextForList } from '../../../../Model/Questionnaire'

export interface ICreditCommonPageProps {
    localizationStore?: LocalizationStore
    httpActionsService?: HttpActionsService
    creditsStore: CreditsStore
    configStore: ConfigStore
    notificationsStore: NotificationsStore
}

@inject('httpActionsService')
@inject('localizationStore')
@inject('creditsStore')
@inject('configStore')
@inject('notificationsStore')
@observer
class CreditCommonPage extends React.Component<ICreditCommonPageProps> {
    constructor(props: any) {
        super(props)

        if (this.props['match']!['params']['number']) {
            this.props.httpActionsService!.getCreditByNumber(this.props['match']!['params']['number'])
        }
    }

    @action.bound
    setLanguage(key: 'RU' | 'EN' | 'AZ') {
        LocalizationStore.getInstance().setLanguage(key)
    }

    languageBar() {
        if (this.props.configStore.showLangs) {
            return (
                <span className="nav langs" hidden={!this.props.configStore.showLangs}>
                    <LanguageSelectorView setLanguage={this.setLanguage!} />
                </span>
            )
        }
        return ''
    }

    render() {
        const { localizationStore, creditsStore } = this.props
        var credit = creditsStore.getItem!
        if (!credit) {
            return (
                <div className="App">
                    <NotificationsView />
                    <div className="wrapper">

                        <PageView>
                            {
                                <div className="credit-common-page row">
                                    <Row>
                                        <Col xs={12} sm={8} md={8} lg={8}>
                                            <Header>
                                                {localizationStore!.t('Credit Common Page')}
                                            </Header>
                                        </Col>
                                        <Col xs={12} sm={4} md={4} lg={4}>
                                            {this.languageBar()}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <Header>
                                                {localizationStore!.t('no data')}
                                            </Header>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        </PageView>
                    </div>
                </div>
            )
        }

        let progress = 0

        if (credit!.creditDetail.balance && credit!.creditDetail.totalSum) {
            progress = _.round((credit!.creditDetail.balance / credit!.creditDetail.totalSum) * 100, 0)
        }

        return (
            <div className="App">
                <div className="wrapper">
                    <PageView>
                        {
                            <div className="credit-common-page row">
                                <div className="container">
                                    <Row>
                                        <Col xs={10} sm={10} md={10} lg={10}>
                                            <img src="/images/logo.svg" alt="" />
                                        </Col>

                                        <Col xs={2} sm={2} md={2} lg={2}>
                                            {this.languageBar()}
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <Header>
                                                {localizationStore!.t('Credit Common Page')}
                                                {
                                                    credit && credit.questionnaire && credit.questionnaire.status ?
                                                        <span
                                                            className={
                                                                'text-right ' +
                                                                getQuestionnaireStatusClass(credit.questionnaire.status)
                                                                    .toString()
                                                            }
                                                        >
                                                            {
                                                                getQuestionnaireStatusTextForList(
                                                                    credit.questionnaire.status)
                                                            }
                                                        </span>
                                                        :
                                                        null
                                                }
                                            </Header>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <CreditView
                                            anonymousView={true}
                                            credit={credit}
                                            className="col-12 blockCredit"
                                        />
                                    </Row>

                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <DebtInfoView anonymousView={true} credit={credit} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <ProgressBar
                                                className="h-40-px"
                                                bsStyle="success bg-success"
                                                striped
                                                now={progress}
                                                label={`${progress}% process is done`}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col xs={12} sm={6} md={6} lg={6}>
                                            <PaymentsView className="col-12" payments={credit.payments} />
                                        </Col>
                                        <Col xs={12} sm={6} md={6} lg={6}>
                                            <Row>
                                                <PaymentScheduleView
                                                    className="col-12"
                                                    scheduleArr={
                                                        getPaymentSchedule(
                                                            credit!.creditCondition!.paymentsScheduleJson)
                                                    }
                                                    prepaymentSum={credit!.creditCondition!.prepaymentSum}
                                                />
                                            </Row>
                                            <Row>
                                                <p>{localizationStore!.t!('products')}</p>
                                            </Row>
                                            <Row className="blockProducts m-0">
                                                <ProductsListView className="col-12" products={credit.products} />
                                            </Row>
                                            <Row className="mt-2">
                                                <div className="offset-6 col-6 blockProductsSum text-right">
                                                    {localizationStore!.t!('totalSum')}
                                                    <mark>
                                                        {
                                                            getProductsSum(credit.products).toFixed(2)
                                                        }
                                                    </mark>
                                                </div>
                                            </Row>
                                        </Col>
                                    </Row>
                                    {/* <Row className="mt-4">
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <iframe
                                                className="w-100 h-440-px"
                                                src="https://sezam.az/contacts"
                                            />
                                        </Col>
                                    </Row> */}
                                </div>
                            </div>
                        }
                    </PageView>
                </div>
            </div>
        )
    }
}

export default withRouter(CreditCommonPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Credit/CreditCommonPage/index.tsx